<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 점검 정보 -->
    <div class="mt-5 mb-6">
      <p class="title my-4"><i class="dot"></i>점검정보</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">담당부서</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>
          <company-selector
            v-else
            v-model="form.inputB_0"
            @select="targetCompany"
            :readonly="board.readonly"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">점검자명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">점검일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder="날짜선택"
            v-model="form.inputB_3"
          />
        </div>
      </div>
    </div>

    <!--    점검항목-->
<!--    <table-inspect-division-ep-->
<!--      class="mt-2"-->
<!--      :is-print="isPrint"-->
<!--      :is-readonly="board.readonly"-->
<!--      :is-show-title="true"-->
<!--      title="안전보건 체크리스트"-->
<!--      :list="form.inspectList"-->
<!--      @update-list-check="updateListCheck"-->
<!--    />-->
    <table-inspect-merge
      v-show="isOldVersion"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="안전보건 체크리스트"
      :tableHeaderTitle="[{ text: '의무사항' },{ text: '관계법령' }, {text: '세부내용', width: '272px' }, {text: '점검 항목', width: '272px' }, {text: '해당 부서', width: '100px' }]"
      :tableHeaderCheck="[{ text: '실시' }, { text: '미실시' }, { text: '해당없음' }]"
      :tableHeaderNote="{ text: '비고(보완계획)', width: '200px' }"
      :numbering="true"
      v-model="form.inspectList"
      class="mt-28px"
    />

    <table-inspect-merge
      v-show="!isOldVersion"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="안전보건 체크리스트"
      tableHeaderTitle="점검항목"
      :tableHeaderCheck="[{ text: '이행' }, { text: '미이행' }, { text: '해당없음' }]"
      :tableHeaderNote="{ text: '비고', width: '200px' }"
      :numbering="false"
      v-model="form.inspectList2"
      class="mt-28px"
    />

    <!--    사진대지-->
    <photo-upload-grid-module
      v-show="isOldVersion"
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검" />
    <div v-show="!isOldVersion" class="grid grid-cols-3 gap-4">
      <photo-upload-grid-module
        :row-count="1"
        :grid-count="1"
        :is-check-mode="false"
        v-model="form.photoList1"
        :is-print="isPrint"
        :readonly="board.readonly"
        section-title="안전보건관리규정 게시"
      />

      <photo-upload-grid-module
        :row-count="1"
        :grid-count="1"
        :is-check-mode="false"
        v-model="form.photoList2"
        :is-print="isPrint"
        :readonly="board.readonly"
        section-title="산업안전보건법 요지 게시"
      />

      <photo-upload-grid-module
        :row-count="1"
        :grid-count="1"
        :is-check-mode="false"
        v-model="form.photoList3"
        :is-print="isPrint"
        :readonly="board.readonly"
        section-title="작업장 정리정돈 등"
      />
    </div>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "./inspectData";
export default {
  components: {
    TableInspectMerge,
    CompanySelector,
    DateSelector,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    isOldVersion() {

      let oldVersion = false;

      this.form.inspectList.forEach(item => {
        if (item.isChecked) {
          oldVersion = true;
        }
      })

      return oldVersion;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        // self-emit echo (parent.form.body === this.form)는 무시 → 무한 루프 차단
        if (value === this.form) return;

        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
        // 외부 데이터가 들어올 때마다 머지 → 최신 템플릿 문구 적용 (오타 수정 반영)
        if (Array.isArray(this.form.inspectList) && this.form.inspectList.length > 0) {
          this.form.inspectList = this.mergeInspectList(inspectData.inspectTable, this.form.inspectList);
        }
        if (Array.isArray(this.form.inspectList2) && this.form.inspectList2.length > 0) {
          this.form.inspectList2 = this.mergeInspectList(inspectData.inspectTable2, this.form.inspectList2);
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",

        inspectList: inspectData.inspectTable,
        inspectList2: inspectData.inspectTable2,

        stdInfo: {},
        fileList: [],
        photoList: [],
        photoList1: [],
        photoList2: [],
        photoList3: [],
      },
    };
  },
  methods: {
    targetCompany(value) {
      this.form.inputB_1 = value.com_name;
    },
    updateListCheck(indexTableRow, indexRows, text) {
      this.form.inspectList[indexTableRow].list[indexRows].is_checked = text;
    },
    mergeInspectList(template, saved) {
      if (!Array.isArray(saved) || saved.length === 0) {
        return JSON.parse(JSON.stringify(template));
      }
      const savedHasKeys = saved.some(item => item && item.key);
      return template.map((row, i) => {
        const savedRow = savedHasKeys
          ? saved.find(s => s && s.key === row.key)
          : saved[i];
        if (!savedRow) {
          return JSON.parse(JSON.stringify(row));
        }
        // 템플릿 row를 기반(deep clone)으로 시작 → title/content 등 모든 구조 필드가 항상 최신
        // 사용자 입력값(isChecked, is_checked, note)만 saved에서 덮어쓰기
        const merged = JSON.parse(JSON.stringify(row));
        if (savedRow.isChecked !== undefined) merged.isChecked = savedRow.isChecked;
        if (savedRow.is_checked !== undefined) merged.is_checked = savedRow.is_checked;
        if (savedRow.note !== undefined) merged.note = savedRow.note;
        return merged;
      });
    },
  },
  // computed: {
  //   inspectTable () {
  //     return [
  //       {
  //         headerInput1Title: '점검사항',
  //         headerInput2Title: '관계법령',
  //         headerTitle: '점검항목',
  //         headerYesTitle: '실시',
  //         headerNoTitle: '미실시',
  //         headerNATitle: '해당없음',
  //         headerNoteTitle: '비고(보완계획)',
  //         isTypeMode : true,
  //         isInputMode: false,
  //         isInput1 : true,
  //         isInput2 : true,
  //         isInput3 : false,
  //         isNote : true,
  //         inputWidth1: '0.7fr',
  //         inputWidth2: '0.5fr',
  //         footer: '※ (중처법=중대재해처벌 등에 관한 법률. 산안법=산업안전보건법)',
  //         list: [
  //           {
  //             id: 1,
  //             type: '1',
  //             is_checked: '',
  //             input1: '안전보건관리체계 구축',
  //             input2: '중처법 시행령 제4조제8호',
  //             label: '부서별 안전보건관리계획 작성여부',
  //           },
  //           {
  //             id: 2,
  //             type: '2',
  //             is_checked: '',
  //             input1: '신규 채용시 교육',
  //             input2: '산안법 제29조',
  //             label: '8시간 (일용근로자 1시간)',
  //           },
  //           {
  //             id: 3,
  //             type: '3',
  //             is_checked: '',
  //             input1: '정기 안전 보건 교육',
  //             input2: '산안법 제29조',
  //             label: '현업업무 (6시간/분기)',
  //           },
  //           {
  //             id: 4,
  //             type: '4',
  //             is_checked: '',
  //             input1: '특별 안전 보건 교육',
  //             input2: '산안법 제29조',
  //             label: '2시간 (단기간 간헐적 근로자, 일용근로자)',
  //           },
  //           {
  //             id: 5,
  //             type: '5',
  //             is_checked: '',
  //             input1: '특별 안전 보건 교육',
  //             input2: '산안법 제29조',
  //             label: '16시간',
  //           },
  //           {
  //             id: 6,
  //             type: '6',
  //             is_checked: '',
  //             input1: '법령의 요지',
  //             input2: '산안법 제34조',
  //             label: '작업장(현장 등)별 게시',
  //           },
  //           {
  //             id: 7,
  //             type: '7',
  //             is_checked: '',
  //             input1: '안전보건관리규정',
  //             input2: '산안법 제34조',
  //             label: '작업장(현장 등)별 게시',
  //           },
  //           {
  //             id: 8,
  //             type: '8',
  //             is_checked: '',
  //             input1: '중대산업재해 및 위험 대비 매뉴얼',
  //             input2: '중처법 시행령 제4조 제8호',
  //             label: '급박한 위험(산업재해 발생) 대비 매뉴얼(상황별)마련 및 조치',
  //           },
  //           {
  //             id: 9,
  //             type: '9',
  //             is_checked: '',
  //             input1: '산업재해 보고 관련',
  //             input2: '산안법 제54조',
  //             label: '산업재해 보고, 응급조치, 재발방지 계획서',
  //           },
  //           {
  //             id: 10,
  //             type: '10',
  //             is_checked: '',
  //             input1: '산업재해 보고 관련',
  //             input2: '산안법 제54조',
  //             label: '산업재해에 관한 통계의 기록 및 유지',
  //           },
  //           {
  //             id: 11,
  //             type: '11',
  //             is_checked: '',
  //             input1: '수시 위험성평가(수시평가 : 산재발생 등)',
  //             input2: '산안법 제36조',
  //             label: '산업재해 발생으로 실시 및 감소대책실행종사자 안전보건교육 실시',
  //           },
  //           {
  //             id: 12,
  //             type: '12',
  //             is_checked: '',
  //             input1: '위험성평가',
  //             input2: '산안법 제36조',
  //             label: '위험성평가 실시 시 종사자 참여',
  //           },
  //           {
  //             id: 13,
  //             type: '13',
  //             is_checked: '',
  //             input1: '위험성평가',
  //             input2: '산안법 제36조',
  //             label: '위험성평가 실시\n' +
  //               '(추락, 끼임, 부딪힘 등  3대사망 위험 요인 반영)',
  //           },
  //           {
  //             id: 14,
  //             type: '14',
  //             is_checked: '',
  //             input1: '위험성평가',
  //             input2: '산안법 제36조',
  //             label: '유해·위험요인 파악, 감소대책 수립 및 실행',
  //             noteCountList: [
  //               { label: '위험요인', value: '', unit: '건' },
  //               { label: '개선 중', value: '', unit: '건' },
  //               { label: '개선완료', value: '', unit: '건' },
  //             ],
  //           },
  //           {
  //             id: 15,
  //             type: '15',
  //             is_checked: '',
  //             input1: '위험성평가',
  //             input2: '산안법 제36조',
  //             label: '위험성평가 후 종사자 전파',
  //           },
  //           {
  //             id: 16,
  //             type: '16',
  //             is_checked: '',
  //             input1: '위험기계·기구, 방호장치',
  //             input2: '산안법 시행령 제15조 제1호',
  //             label: '해당 작업과 관련된 기계·기구 또는 설비의 안전· 보건 점검 및 이상 유무 확인',
  //           },
  //           {
  //             id: 17,
  //             type: '17',
  //             is_checked: '',
  //             input1: '안전검사 (대상설비 : 컨베이어,크레인, 고소작업대 등 15종)',
  //             input2: '산안법 시행령 제15조 제1호',
  //             label: '안전검사 (합격/불합격) 및 검사 주기 작성 및 관리해당 있는 부서는 (대상기계기구 보유현황 및 점검일지, 안전검사필증(사진), 검사주기 등',
  //           },
  //           {
  //             id: 18,
  //             type: '18',
  //             is_checked: '',
  //             input1: '지게차, 페이로더, 크레인, 굴착기,하역운반기계 등 작업전 작업계획서',
  //             input2: '산안법 시행령 제15조 제1호',
  //             label: '작업계획서 작성 및 서류보관',
  //           },
  //           {
  //             id: 19,
  //             type: '19',
  //             is_checked: '',
  //             input1: '보호구',
  //             input2: '산안법 시행령 제15조 제2호',
  //             label: '해당 작업에 필요한 작업복, 보호구의 점검, 지급 및 착용 지도',
  //           },
  //           {
  //             id: 20,
  //             type: '20',
  //             is_checked: '',
  //             input1: '보호구',
  //             input2: '산안법 시행령 제15조 제2호',
  //             label: '보호구 지급 대장 작성',
  //           },
  //           {
  //             id: 21,
  //             type: '21',
  //             is_checked: '',
  //             input1: '정리·정돈',
  //             input2: '산안법 시행령 제15조 제4호',
  //             label: '해당 작업의 작업장 정리·정돈 및 통로 확보에 대한 확인·감독',
  //           },
  //           {
  //             id: 22,
  //             type: '22',
  //             is_checked: '',
  //             input1: '정리·정돈',
  //             input2: '산안법 시행령 제15조 제4호',
  //             label: '비상 통로 등에 대한 확보',
  //           },
  //           {
  //             id: 23,
  //             type: '23',
  //             is_checked: '',
  //             input1: '산업재해 예방을 위한 현장점검',
  //             input2: '산안법 시행령 제15조 제5호',
  //             label: '안전관리자, 보건관리자, 산업보건의 등  지도·조언에대한 협조',
  //           },
  //           {
  //             id: 24,
  //             type: '24',
  //             is_checked: '',
  //             input1: '안전 보건 표지',
  //             input2: '산안법 제37조',
  //             label: '위험장소에 안전 표시 부착\n' +
  //               '(넘어짐, 계단주의, 화상주의, 중량물취급작업 등)',
  //           },
  //           {
  //             id: 25,
  //             type: '25',
  //             is_checked: '',
  //             input1: '물질안전보건자료',
  //             input2: '산안법 제114조',
  //             label: 'MSDS 게시',
  //           },
  //           {
  //             id: 26,
  //             type: '26',
  //             is_checked: '',
  //             input1: '물질안전보건자료',
  //             input2: '산안법 제114조',
  //             label: 'MSDS 경고표지 부착',
  //           },
  //           {
  //             id: 27,
  //             type: '27',
  //             is_checked: '',
  //             input1: '물질안전보건자료',
  //             input2: '산안법 제114조',
  //             label: 'MSDS 교육실시, 교육일지',
  //           },
  //           {
  //             id: 28,
  //             type: '28',
  //             is_checked: '',
  //             input1: '근골격계 유해 요인 조사',
  //             input2: '안전보건규칙 제657조',
  //             label: '근골격계 유해 요인 조사 결과 개선 조치',
  //           },
  //           {
  //             id: 29,
  //             type: '29',
  //             is_checked: '',
  //             input1: '작업환경 측정',
  //             input2: '산안법 제125조',
  //             label: '작업환경측정 결과 근로자에게 공지',
  //           },
  //           {
  //             id: 30,
  //             type: '30',
  //             is_checked: '',
  //             input1: '작업환경 측정',
  //             input2: '산안법 제125조',
  //             label: '작업환경 개선 조치',
  //           },
  //           {
  //             id: 31,
  //             type: '31',
  //             is_checked: '',
  //             input1: '밀폐공간 작업 프로그램',
  //             input2: '안전보건규칙 제619조',
  //             label: '밀폐공간 작업 프로그램 수립',
  //           },
  //           {
  //             id: 32,
  //             type: '32',
  //             is_checked: '',
  //             input1: '밀폐공간 작업 프로그램',
  //             input2: '안전보건규칙 제619조',
  //             label: '밀폐공간 작업 프로그램 실시',
  //           },
  //           {
  //             id: 33,
  //             type: '33',
  //             is_checked: '',
  //             input1: '건강진단',
  //             input2: '산안법 제132조',
  //             label: '일반건강진단 실시',
  //           },
  //           {
  //             id: 34,
  //             type: '34',
  //             is_checked: '',
  //             input1: '건강진단',
  //             input2: '산안법 제132조',
  //             label: '특수건강진단 실시',
  //           },
  //           {
  //             id: 35,
  //             type: '35',
  //             is_checked: '',
  //             input1: '휴게시설의 설치',
  //             input2: '산안법 제128조의2',
  //             label: '휴게실 현황',
  //           },
  //           {
  //             id: 36,
  //             type: '36',
  //             is_checked: '',
  //             input1: '서류의 보존',
  //             input2: '산안법 제164조',
  //             label: '보존 연한 준수',
  //           },
  //           {
  //             id: 37,
  //             type: '37',
  //             is_checked: '',
  //             input1: '안전보건 예산의 편성 여부',
  //             input2: '중대재해처벌법 시행령 제4조 제4호',
  //             label: '산업안전보건을 위한 시설비, 안전 및 보건관리 장비 구입 비용\n' +
  //               '안전장구류(개인 보호구 구입 등)\n' +
  //               '시설/기계 점검/ 보수 비용\n' +
  //               '교육 훈련 비용/재해예방을 위한 인력 비용\n' +
  //               '기타(산업 안전 관련 예산)',
  //           },
  //         ]
  //       },
  //     ]
  //   },
  // }
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 20px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;
    position: relative;
    &::before {
      content: "~";
      width: 10px;
      position: absolute;
      left: -15px;
      text-align: center;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
</style>
